import { useUserStore } from '@Auth/store';
import { authProvider } from '@helpers/auth';
import type { AxiosRequestConfig } from 'axios';
import { merge } from 'lodash-es';

import { isPPLFrontend } from '../utils/app-paths';

export const getRequestAuthPayload = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  const controller = new AbortController();

  const baseConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
      companyId: !isPPLFrontend
        ? useUserStore.getState().user?.tenantId || useUserStore.getState().user?.companyId
        : undefined,
    },
    baseURL: isPPLFrontend ? import.meta.env?.VITE_API_URL : import.meta.env?.VITE_API_V2_URL,
    signal: controller.signal,
  };

  const networkAuthPayload = await authProvider.getNetworkAuthPayload();

  if (!networkAuthPayload) {
    controller.abort('No auth payload received');
  }

  return merge(baseConfig, networkAuthPayload ?? {}, config);
};
